<template>
  <div class="meetings-list">
    <h1>已申请报名{{ acType }},{{ time }},{{ city }}站活动</h1>
    <p>{{ title }}</p>
    <h2>
      {{
        timeType === "all" ? "全部" : timeType === "am" ? "上午" : "下午"
      }}-累计报名人数:{{ count }},已通过人数:{{ passed }},已拒绝人数：{{
        rejected
      }},上午通过人数：{{ amPeople }}，下午通过人数：{{ pmPeople }}
    </h2>
    <h2>已发送短信人数:{{ send }},未发送人数:{{ notsend }}</h2>
    <div>
      <el-button @click="getExcel">下载已报名用户数据</el-button>
      <el-select
        v-model="timeType"
        placeholder="请选择"
        @change="getUserList(acType, acId)"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
    <el-table :data="tableShow" :row-key="getRowKeys">
      <el-table-column prop="id" label="参会人ID" />
      <el-table-column prop="uniqueCode" label="参会人code" />
      <el-table-column prop="company" label="公司名" />
      <el-table-column prop="name" label="姓名" />
      <el-table-column prop="job" label="职位" />
      <el-table-column prop="mail" label="邮箱" />
      <el-table-column prop="phone" label="手机号" />
      <el-table-column prop="wechat" label="微信号" />
      <el-table-column prop="remark" label="备注" />
      <el-table-column prop="card" label="名片">
        <template slot-scope="scope">
          <el-popover
            ref="scope"
            width="500"
            trigger="hover"
            placement="left-start"
            offset="12"
          >
            <img :src="scope.row.card" width="100%" />
            <el-button slot="reference" type="text">
              <a :href="scope.row.card" target="_blank">查看名片</a>
            </el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="timeType" label="时间" />
      <el-table-column
        prop="sms"
        label="短信"
        :filters="[
          { text: '已发送', value: 'send' },
          { text: '未发送', value: 'notsend' },
        ]"
        :filter-method="filterSms"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.sms == 'send'" class="need-passed">已发送</span>
          <span v-else class="need-pass">未发送</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="status"
        label="审核"
        :filters="[
          { text: '待审核', value: '0' },
          { text: '已过审', value: '1' },
          { text: '已拒审', value: '2' },
        ]"
        :filter-method="filterStatus"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0" class="need-pass">待审核</span>
          <span v-else-if="scope.row.status == 1" class="need-passed"
            >已过审</span
          >
          <span v-else class="need-failed">已拒审</span>
        </template>
      </el-table-column>
      <el-table-column label="审核操作">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0">
            <el-button @click="passUser(scope.row.id)" type="text" size="small"
              >通过</el-button
            >
            <el-button
              @click="rejectUser(scope.row.id)"
              type="text"
              size="small"
              >拒绝</el-button
            >
          </span>
        </template>
      </el-table-column>

      <el-table-column label="短信操作">
        <template slot-scope="scope">
          <el-button
            @click="
              rejectSms(
                scope.row.id,
                scope.row.phone,
                scope.row.phoneCode,
                scope.row
              )
            "
            type="text"
            size="small"
            v-if="scope.row.status == 2 && scope.row.sms == 'notsend'"
            >发送拒绝短信</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      tableShow: [],
      tableData: [],
      page: 1,
      count: 0,
      passed: 0,
      rejected: 0,
      city: null,
      time: 0,
      send: 0,
      notsend: 0,
      title: null,
      timeType: "all",
      pmPeople: 0,
      amPeople: 0,
      options: [
        {
          value: "am",
          label: "上午",
        },
        {
          value: "pm",
          label: "下午",
        },
        {
          value: "all",
          label: "全部",
        },
      ],
    };
  },
  methods: {
    checkSessionUserNumber() {
      this.$http
        .checkSessionUserNumber([parseInt(this.acId)], this.acType)
        .then((res) => {
          if (res.data.statusCode === 200) {
            this.pmPeople = res.data.result.pm[this.acId];
            this.amPeople = res.data.result.am[this.acId];
          }
        });
    },
    getUserList(acType, acId) {
      console.log(acType, acId);
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let timeType = this.timeType;
      this.$http
        .meetingUser(acType, acId, ["notsend", "send"], [0, 1, 2], timeType)
        .then((res) => {
          loading.close();
          if (res.data.statusCode === 200) {
            this.tableShow = res.data.result;
            this.count = res.data.result.length;
            this.time = moment(res.data.result.startTime).format(
              "YYYY-MM-DD hh:mm"
            );
            this.passed = res.data.result.filter(
              (item) => item.status === "1"
            ).length;
            this.rejected = res.data.result.filter(
              (item) => item.status === "2"
            ).length;
            this.send = res.data.result.filter(
              (item) => item.sms === "send"
            ).length;
            this.notsend = res.data.result.filter(
              (item) => item.sms === "notsend"
            ).length;
          } else if (res.data.statusCode === 404) {
            this.$message.error("暂无符合该条件的数据" + res.data.message);
          } else {
            this.$message.error("请求数据失败" + res.data.message);
          }
        });
    },
    filterSms(value, row) {
      return row.sms == value;
    },
    filterStatus(value, row) {
      return row.status == value;
    },
    passUser(id) {
      this.$http
        .ac_user_review("pass", id, this.acId, this.acType)
        .then((res) => {
          this.getUserList(this.acType, this.acId);
        });
    },
    rejectUser(id) {
      this.$http.ac_user_review("reject", id, this.acId).then((res) => {
        this.getUserList(this.acType, this.acId);
      });
    },
    rejectSms(id, phone, nationCode, data) {
      let title = `${this.title}·${this.city}站`;
      this.$http
        .qsmsService({
          phone,
          nationCode,
          id,
          title,
          smsType: "reject",
        })
        .then((res) => {
          if (res.data.statusCode === 200) {
            this.$notify({
              title: "发送短信成功",
              message: "成功发送拒绝短信," + phone,
              type: "success",
            });
            this.getUserList(this.acType, this.acId);
          } else {
            this.$notify.error({
              title: "发送短信失败",
              message: res.data.message,
            });
          }
        });
    },
    getCityInfo(type, id) {
      if (type === "freetalks") {
        this.$http.freetalks_detail(id).then((res) => {
          if (res.data.statusCode === 200) {
            this.city = res.data.result.city;
            this.title = res.data.result.title;
          }
        });
      }
      if (type === "hkstocks") {
        this.$http.hkstocks_detail(id).then((res) => {
          if (res.data.statusCode === 200) {
            this.city = res.data.result.city;
            this.title = res.data.result.title;
          }
        });
      }
      if (type === "roadshow") {
        this.$http.roadshow_detail(id).then((res) => {
          if (res.data.statusCode === 200) {
            this.city = res.data.result.city;
            this.title = res.data.result.title;
          }
        });
      }
      if (type === "enroll") {
        this.$http.getEnrollDetail(id).then((res) => {
          if (res.data.statusCode === 200) {
            this.city = res.data.result.city;
            this.title = res.data.result.title;
          }
        })
      }
      this.checkSessionUserNumber();
    },
    getRowKeys(row) {
      return row.id;
    },
    getExcel() {
      console.log("查询数据excel数据");
      window.open(
        `/acapi/file/users/${this.acType}/${this.acId}/send,notsend/0,1,2`
      );
    },
  },
  computed: {
    acType() {
      return this.$route.params.acType;
    },
    acId() {
      return this.$route.params.acId;
    },
  },
  mounted() {
    this.getUserList(this.acType, this.acId);
    this.getCityInfo(this.acType, this.acId);
  },
};
</script>

<style scoped>
.need-pass {
  color: #fa5555;
}

.need-passed {
  color: #67c23a;
}

.need-failed {
  color: #878d99;
}

.normal-pagination {
  overflow: hidden;
}

.send-all-user-container {
  float: right;
  padding: 20px 0;
}

.meetings-list h1,
.meetings-list h2 {
  font-size: 16px;
  font-weight: normal;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/meetingUsersList.vue